import React from "react";
import { NavLink } from "react-router-dom";

export default function ManagerAdminHome() {
    return (
        <div className="card">
            <h1>Liga Manager Admin</h1>
            <p>Hier findest du alle Admin Funktionen für den Liga Manager.</p>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
                <NavLink className="btn" to="/manager/admin/name-import">Name Import</NavLink>
                <NavLink className="btn" to="/manager/admin/import">Standings Import</NavLink>
                <NavLink className="btn" to="/manager/admin/users">User</NavLink>
            </div>
        </div>
    );
}